<stch-date-time-picker
  appearance="text"
  [textLabel]="startLabel()"
  [dateControl]="fromDate()"
  [timeControl]="fromTime()"
  [allDay]="allDay()"
  [max]="startMax()"
  [range]="range()"
  rangeEnd="start"
/>
<span class="header-dates-rule" aria-hidden="true"></span>
<stch-date-time-picker
  class="header-dates-due"
  appearance="text"
  [textLabel]="dueLabel()"
  [dateControl]="toDate()"
  [timeControl]="toTime()"
  [allDay]="allDay()"
  [min]="dueMin()"
  [range]="range()"
  rangeEnd="end"
  [overdue]="overdue()"
/>
